module.exports = __webpack_public_path__ + "static/media/avatar.a167eb59.jpg";